import { useTranslation } from "react-i18next";
import type { ConnectorSummary } from "@/api";
import { deleteConnectorMutation, listConnectorsQueryKey } from "@/api";
import { useDeleteEntity } from "@/components/build/useDeleteEntity";

/** Delete-with-confirm for a connector (its admins). */
export function useDeleteConnector(onDeleted?: () => void) {
  const { t } = useTranslation("connectors");
  return useDeleteEntity<ConnectorSummary>({
    mutation: deleteConnectorMutation(),
    listQueryKey: listConnectorsQueryKey,
    pathFor: (c) => ({ connector_uuid: c.uuid }),
    messages: { deleted: t("deleted"), deleteFailed: t("deleteFailed") },
    onDeleted,
  });
}
